// extracted by mini-css-extract-plugin
module.exports = {"container":"Statistics_container__3Qvj2"};